import { styled } from '@mui/system'
import Typography from '../../../atoms/typography'
import Button from '../../button'
import { Chip } from '@bluheadless/ui/src/molecules/tag/tag.styled'

const Root = styled('div')`
	margin-bottom: 40px;

	&.inline-filter {
		margin-top: var(--spacing-3);
		margin-bottom: ${({ theme }) => theme.spacing(2)};
		border-bottom: 0;
		padding-top: 21px;
		border-top: 1px solid ${({ theme }) => theme.palette.grey.light};
	}
`

const Title = styled(Typography)`
	margin-bottom: ${({ theme }) => theme.spacing(4)};
`

const List = styled('div')`
	display: flex;
	flex-wrap: wrap;
	gap: ${({ theme }) => theme.spacing(1)};
	margin-bottom: var(--spacing-3);
	max-width: 90%;

	&.inline-filter {
		gap: var(--spacing-3);
		margin-bottom: 0;
	}

	${Chip} {
		border-color: currentColor;
		color: currentColor;
	}
`

const Grid = styled('div')`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: var(--spacing-3);
`

const ButtonClearAll = styled(Button)``

export { Root, Title, List, Grid, ButtonClearAll }
